const featureFlagsMiddleware =
  ({ getState }) =>
  (next) =>
  (action) => {
    const { feature_flags } = getState();
    action._multiple_assignees = feature_flags && feature_flags.includes("multiple_assignees");
    return next(action);
  };

export default featureFlagsMiddleware;
